import { Locale } from 'ha/i18n';

import formatDate from './formatDate';
import fromNow from './fromNow';
import toLocalizedString from './toLocalizedString';

export { default as formatDate } from './formatDate';
export { default as toLocalizedString } from './toLocalizedString';
export { default as diffDay } from './diffDay';
export { default as isDayBetween } from './isDayBetween';
export { default as daysToMonths } from './daysToMonths';
export { default as addDays } from './addDays';
export { default as addMonths } from './addMonths';
export { default as addYears } from './addYears';
export { default as getDateOfMonth } from './getDateOfMonth';
export { default as getAbsoluteDaysDiff } from './getAbsoluteDaysDiff';
export { default as isBefore } from './isBefore';
export { default as isValidDate } from './isValidDate';
export { default as subtractMonths } from './subtractMonths';
export { default as getToday } from './getToday';
export { default as getDay } from './getDay';
export { default as getMonth } from './getMonth';
export { default as getYear } from './getYear';
export { default as getMonthsBetween } from './getMonthsBetween';
export { default as doRangesOverlap } from './doRangesOverlap';
export { default as diff } from './diff';
export { default as startOf } from './startOf';
export { default as year } from './year';
export { default as isFormat } from './isFormat';

export const NO_START = '0001-01-01T00:00:00Z';
export const NO_END = '9999-12-31T00:00:00Z';
export const NO_END_DATE = '9999-12-31';
export const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;

const haDateFactory = (locale: Locale) => ({
  locale,
  formatDate: formatDate(locale),
  fromNow: fromNow(locale),
  toLocalizedString: toLocalizedString(locale),
});

export default haDateFactory;
